/**
 * @file step
 * @author zhaomiaoyuan
 */
import React, {useEffect} from 'react';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';
import RadioFormItem from '../../components/RadioFormItem/index.tsx';
import CallingCardSelect from '../../components/CallingCard/callingCardSelect.tsx';
import PersonModal from './personModal';
import CompanyModal from './companyModal';
import GovernmentModal from './governmentModal';
import {recordProxy} from '../../util';
import {initialStateErr} from './conf';
// import {appealTypeEventTracking} from './conf';
// import {reg9, reg400800} from '../../components/util';

import './appeal.less';
const Step2 = (props) => {
    const {
        updateAppeal,
        appealData
    } = props;
    const options = [{
        label: '个人',
        value: 1
    }, {
        label: '企业',
        value: 2
    }, {
        label: '政府',
        value: 3
    }];

    useEffect(() => {
        // 400/800/95/96号码实际归属只有企业和政府，默认选择企业
        // 保证上一步点击操作原归属类型不变
        // if (reg9.test(appealData.phone) || reg400800.test(appealData.phone)) {
        //     setOptions([{
        //         label: '企业',
        //         value: 2
        //     }, {
        //         label: '政府',
        //         value: 3
        //     }]);
        //     if (appealData.attributionType !== 3) {
        //         updateAppeal({
        //             attributionType: 2
        //         });
        //     }
        // } else if (appealData.attributionType === 1) {
        //     updateAppeal({
        //         attributionType: 1
        //     });
        // }
    }, [appealData.phone]);
    function rewrite() {
        // let personPhoneType = '';
        // if (appealData.attributionType === 1) {
        //     const rePhone = /^1[3456789]\d{9}$/;
        //     personPhoneType = rePhone.test(appealData.phone) ? 'Phone' : 'TelPhone';
        // }
        // recordProxy(
        //     'rewrite',
        //     'click',
        //     appealTypeEventTracking[appealData.attributionType] + personPhoneType
        // );
        recordProxy('rewrite', 'click', '');
        updateAppeal({
            curStep: 1,
            attributionType: 1,
            hasSearchUrl: false, // 外链跳转
            ...initialStateErr
        });
        window.scrollTo(0, 0);
    }
    const onChangeCallback = (val) => {
        updateAppeal({
            phone: val.phone,
            [appealData.appealType === 2 ? 'phoneName' : 'titleName']: val.name
        });
    };
    // const onAttributionTypeChange = e => {
    //     recordProxy('phoneAttribution', 'click', appealTypeEventTracking[e.target.value]);
    //     // let personPhoneType = '';
    //     // if (appealData.attributionType === 1) {
    //     //     const rePhone = /^1[3456789]\d{9}$/;
    //     //     personPhoneType = rePhone.test(appealData.phone) ? 'Phone' : 'TelPhone';
    //     // }
    //     // recordProxy('phoneAttribution', 'click',
    //     //     appealTypeEventTracking[appealData.attributionType]
    //     //     + personPhoneType
    //     //     + 'To'
    //     //     + appealTypeEventTracking[e.target.value].slice(0, 1).toUpperCase()
    //     // );
    // };
    return (
        <div className="step-2">
            <CallingCardSelect
                data={{
                    phone: appealData.phone,
                    phoneName: appealData.phoneName,
                    titleName: appealData.titleName,
                    phoneList: appealData.phoneList
                }}
                rewrite={rewrite}
                callbackChange={onChangeCallback}
                updateData={updateAppeal}
            />
            <div style={{height: '57px'}}>
                <RadioFormItem
                    title="号码实际归属"
                    isMsgRequired={true}
                    type="attributionType"
                    options={options}
                    data={appealData}
                    updateData={updateAppeal}
                    onChange={() => updateAppeal(initialStateErr)}
                    // onChange={onAttributionTypeChange}
                />
            </div>

            {appealData.attributionType === 1 && <PersonModal {...props}/>}
            {appealData.attributionType === 2 && <CompanyModal {...props}/>}
            {appealData.attributionType === 3 && <GovernmentModal {...props}/>}
        </div>
    );
};

Step2.propTypes = {
    updateAppeal: PropTypes.func,
    appealData: PropTypes.object
};

export default withRouter(Step2);
